import { filterApprovedViewerRows } from './viewerAccess';

function unwrapResponseData(responseData) {
  return responseData?.data ?? responseData ?? {};
}

function isObject(value) {
  return value !== null && typeof value === 'object';
}

function findCollectionItems(source, seen = new Set()) {
  if (Array.isArray(source)) return source;
  if (!isObject(source) || seen.has(source)) return null;
  seen.add(source);

  for (const key of ['items', 'results', 'rows', 'records']) {
    if (Array.isArray(source[key])) return source[key];
  }

  for (const key of ['data', 'result', 'payload']) {
    const nested = source[key];
    const items = findCollectionItems(nested, seen);
    if (items) return items;
  }

  return null;
}

function findPagination(source, seen = new Set()) {
  if (!isObject(source) || seen.has(source)) return null;
  seen.add(source);

  if (source.pagination) return source.pagination;
  if (source.meta?.pagination) return source.meta.pagination;

  for (const key of ['data', 'result', 'payload']) {
    const nested = source[key];
    const pagination = findPagination(nested, seen);
    if (pagination) return pagination;
  }

  return null;
}

export function extractCollectionResponse(responseData, normalize = (value) => value) {
  const payload = unwrapResponseData(responseData);
  const items = findCollectionItems(payload) ?? [];
  const pagination = findPagination(payload) ?? payload?.pagination ?? null;

  return {
    items: filterApprovedViewerRows(items.map(normalize)),
    pagination,
  };
}
